<template>
  <el-menu
    class="head_wrap"
    mode="horizontal"
    background-color="#418ec6"
    text-color="#ffffff"
    active-text-color="#ffffff"
    router
    :ellipsis="false"
  >
    <router-link to="/">
      <img class="logo" src="@/assets/images/logo.png" alt />
    </router-link>
    <div class="flex-grow" />
    <div class="nav_center">
      <template v-for="item in navData">
        <el-menu-item class="head_list" :index="item.url">
          <p>{{ item.value }}</p>
        </el-menu-item>
      </template>

      <el-menu-item class="head_list" index="/help">
        <i class="iconfont iconquestion"></i>
      </el-menu-item>
      <el-menu-item class="head_list" index="/message">
        <i class="iconfont iconnotice"></i>
      </el-menu-item>
      <div class="nav-wrap">
        <div class="nav-title">
          <i
            class="iconfont iconkuaijiecaidan"
            style="font-size: 16px; margin-right: 3px"
          >
          </i>
          <span>服务</span>
          <div class="marker"></div>
          <el-icon>
            <CaretBottom />
          </el-icon>
        </div>
        <ul class="nav-list">
          <li>
            <a href="https://yzb.caigou2003.com/" target="_blank">
              <span>正福易找标</span>
              <div class="slogin">智能标讯工具</div>
            </a>
          </li>
          <li class="point">
            <a href="https://ebook.ycait.com/" target="_blank">
              <span>易采通电子书</span>
              <div class="slogin">全新升级！文字+音频，深度学习政采知识</div>
            </a>
            <div class="marker"></div>
          </li>
          <li>
            <a href="https://www.caigou2003.com/" target="_blank">
              <span>政府采购信息网</span>
              <div class="slogin">权威的政策解读 有用的信息传达</div>
            </a>
          </li>
          <li>
            <a href="https://www.caigou2003.com/web/html/home/yct-intro.html" target="_blank">
              <span>易采通APP</span>
              <div class="slogin">你贴身的政采小秘书</div>
            </a>
          </li>
        </ul>
      </div>
    </div>

    <div class="info" v-if="store.state.userInfo.userid">
      <el-dropdown
        style="text-align: right; margin-right: 6px"
        placement="bottom"
      >
        <div class="el-dropdown-link">
          <p class="username">欢迎 {{ store.state.userInfo.nickname }}</p>
          <p>{{ store.state.userInfo.tel }}</p>
        </div>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item @click="modifyPwd">修改密码</el-dropdown-item>
            <el-dropdown-item @click="signOut">退出</el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
      <el-avatar :size="30">
        <img :src="this.$store.state.userInfo.userpic" />
      </el-avatar>
    </div>
    <div class="info_txt" v-else @click="login">登录/注册</div>
  </el-menu>
</template>

<script setup>
// import { reactive } from "@vue/reactivity";
import { login, modifyPwd, signOut } from "@/utils/sso-login.js";
import { CaretBottom } from "@element-plus/icons-vue";
import { useStore } from "vuex";
const store = useStore();
let navData = [
  {
    value: "首页",
    img: require("@/assets/images/icon/home.png"),
    url: "/",
    class: "home",
  },
  {
    value: "课程",
    img: require("@/assets/images/icon/course.png"),
    url: "/course",
  },
  {
    value: "考试",
    img: require("@/assets/images/icon/exam.png"),
    url: "/exam_list",
  },
  {
    value: "成绩",
    img: require("@/assets/images/icon/grade.png"),
    url: "/result_list",
  },
  {
    value: "证书",
    img: require("@/assets/images/icon/certificate.png"),
    url: "/zs",
  },
  {
    value: "培训记录",
    img: require("@/assets/images/icon/student.png"),
    url: "/train_info",
  },
  {
    value: "订单",
    img: require("@/assets/images/icon/order.png"),
    url: "/order",
  },
];
</script>

<style lang="scss">
.head_wrap {
  min-width: 1070px;
  .logo {
    height: 40px;
    padding: 8px;
  }

  .flex-grow {
    flex-grow: 1;
  }

  .nav_center {
    width: 1000px;
    height: 100%;
    position: absolute;
    left: 0;
    right: 0;
    margin: 0 auto;
    li {
      height: 100%;
    }
    p {
      font-size: 16px;
    }
    i {
      font-size: 16px;
    }
    @media screen and (max-width: 1300px) {
      width: 760px;
    }
  }

  .head_list {
    display: inline-block;
    vertical-align: middle;

    i {
      vertical-align: middle;
      font-size: 18px;
      color: #ffffff;
    }
  }

  .nav-wrap {
    width: 100px;
    text-align: center;
    cursor: pointer;
    padding-top: 18px;
    position: relative;
    display: inline-block;
    vertical-align: middle;

    .nav-title {
      color: #ffffff;

      span {
        font-size: 16px;
      }

      .el-icon {
        display: block;
        text-align: center;
        width: 100%;
      }

      .marker {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background-color: #df3031;
        position: absolute;
        right: 24px;
        top: 14px;
      }
    }

    .nav-list {
      position: absolute;
      padding: 0;
      background: #2b6995;
      width: 100%;
      display: none;
      z-index: 9999999;

      li {
        font-size: 12px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 36px;
        letter-spacing: 1px;
        color: #fbfcfe;
        position: relative;
        list-style: none;
        a {
          text-decoration: none;
          color: #ffffff;
        }

        .slogin {
          position: absolute;
          left: -260px;
          top: 0;
          background: #2b6995;
          width: 260px;
          z-index: 999;
          display: none;
        }

        &:hover {
          background: #5ba6dc;

          .slogin {
            display: block;
            background: #5ba6dc;
          }
        }
      }

      .point {
        font-weight: 900;
        position: relative;

        .marker {
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background-color: #df3031;
          position: absolute;
          right: 8px;
          top: 6px;
        }
      }
    }

    &:hover {
      background: #2b6995;

      .nav-list {
        display: block;
      }

      .el-icon {
        transform: rotate(180deg);
      }
    }
  }

  .info {
    color: #ffffff;
    margin-left: 64px;
    margin-right: 10px;
    font-size: 12px;
    padding: 6px 0;

    .el-dropdown {
      vertical-align: middle;

      .el-dropdown-link {
        color: #ffffff;
        line-height: 20px;
        cursor: pointer;
      }
    }
    .username {
      width: 120px;
      white-space: nowrap; /* 不换行 */
      overflow: hidden; /* 超出部分隐藏 */
      text-overflow: ellipsis; /* 显示省略号 */
    }

    span {
      vertical-align: middle;
      margin-right: 10px;
      display: inline-block;
    }
  }

  .info_txt {
    display: inline-block;
    float: right;
    margin-left: 64px;
    margin-right: 10px;
    font-size: 14px;
    padding-top: 20px;
    cursor: pointer;
    color: #dbdbdb;

    &:hover {
      color: #eb7d29;
    }
  }

  .el-menu-item {
    padding: 0 33.4px;

    @media screen and (max-width: 1300px) {
      padding: 0 20px;
    }
  }
}
</style>
